import { StyleSheet } from "@react-pdf/renderer";

export const css = StyleSheet.create({
    page: {
        backgroundColor: '#ffffff',
        flexDirection: 'column',
        padding: 10,
    },
    row: {
        flexDirection: 'row'
    },
    // Imagenes
    logo: {
        width: 80,
        height: 40,
    },
    //Datos factura: 
    tText: { fontSize: 8 },
    tTextCliente: { fontSize: 7 },
    h1: { fontSize: 16 },
    h2: { fontSize: 15 },
    h3: { fontSize: 14 },
    h4: { fontSize: 13 },
    h5: { fontSize: 12 },
    h6: { fontSize: 10 },
    h7: { fontSize: 9 },

    line: {
        height: 1,
        backgroundColor: '#b1b1b1',
        marginVertical: 1,
    },

    lineBlack: {
        height: 1,
        backgroundColor: '#000000',
        marginVertical: 1,
    },

    lineBlack1: {
        width: '100%',              // Ajusta la línea al ancho del contenedor
        height: 1,                  // Grosor de la línea
        backgroundColor: '#000',     // Color de la línea
        marginVertical: 0,          // Margen para separación
    },

    // Margins | Tops | Paddings
    p_1: { padding: 4 },
    p_2: { padding: 8 },
    p_3: { padding: 16 },
    p_4: { padding: 24 },
    p_5: { padding: 48 },
    px_1: { paddingLeft: 4 },
    py_1: { paddingRight: 8 },
    px_2: { paddingLeft: 8 },
    px_3: { paddingLeft: 16 },
    px_4: { paddingLeft: 24 },
    py_4: { paddingRight: 24 },
    px_5: { paddingLeft: 48 },
    py_5: { paddingRight: 48 },
    px_qr: { paddingLeft: 38 },
    px_6: { paddingLeft: 70 },
    px_7: { paddingLeft: 10 },

    //Aligments
    space_between: { justifyContent: 'space-between' },
    text_center: { textAlign: 'center' },
    text_end: { textAlign: 'right' },
    text_start: { textAlign: 'left' },
    fw_bold: { fontWeight: 'bold' },
    fwBold: { fontWeight: 'bold' },
    text_justify: { textAlign: 'justify' },



    table: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        borderWidth: 1,
        borderColor: '#dee2e6',
    },
    tableRowHeader: {
        flexDirection: 'row',
        backgroundColor: '#f8f9fa',
        borderBottomWidth: 1,
        borderColor: '#dee2e6',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#dee2e6',
    },
    tableCellHeader: {
        flex: 1,
        paddingVertical: 2,
        paddingHorizontal: 4,
        fontSize: 8,
        fontWeight: 'bold',
        borderRightWidth: 1,
        borderColor: '#dee2e6',
    },
    tableCell: {
        flex: 1,
        paddingVertical: 2,
        paddingHorizontal: 4,
        fontSize: 8,
        borderRightWidth: 1,
        borderColor: '#dee2e6',
    },
    lastCell: {
        borderRightWidth: 0,
    },










})